import * as React from 'react';
import { Button, CircularProgress, Typography, Stack, Alert } from '@mui/material';
import RequestDialog from './RequestDialog';
import { useEffect } from 'react';
import { getPartPayments } from 'API/AgentOnboarding/api';
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Snackbar from '@mui/material/Snackbar';
import './FixedTable.css'

export default function PaymentRequestTable(props) {
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [Error, setError] = useState(false)
  const [AlertOpen, setAlertOpen] = useState(false);
  const [DialogParams, setDialogParams] = useState(null);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //   { id: 1,
  //      total_amount: '10000',
  //      bank_name:'SBI',
  //      mode_of_payment: 'Full payment' ,
  //      sign_on_amount:200,
  //      hardware_amount:3000,
  //      due_amount:4000,
  //      due_date:'12/12/2021',
  //      status:'pending',
  //      resend_link:'resend'
  //     },

  // ];

  const [Data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getPartPayments(setData, setIsLoading, setError);
  }, []);

  console.log('data', Data);

  // check

  const handleAlertClose = () => {
    setAlertOpen(false);
    setError(false);
  };

  const handleClickOpen = (params) => {
    console.log(params);
    setDialogParams(params);
    setOpen(true);
  };





  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{ width: '100%' }}>
      <Snackbar open={AlertOpen} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={6000} onClose={handleAlertClose}>

      </Snackbar>
      <Snackbar open={Error} anchorOrigin={{ horizontal: 'right', vertical: 'top' }} autoHideDuration={6000} onClose={handleAlertClose}>
        <Alert onClose={handleAlertClose} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <RequestDialog data={DialogParams} open={open} handleClose={handleClose} />
      {isLoading ? (
        <Stack justifyContent="center" alignItems="center">
          <CircularProgress />
          <Typography mt={1} variant="subtitle1" color="grey">
            Loading...
          </Typography>
        </Stack>
      ) : (
        <Paper sx={{ width: '100%' }}>
          {
            Data && Data.length > 0 ?
              <TableContainer sx={{ maxHeight: 600, width: '100%' }} className="table-container" component={Paper}>
                <Table  size='small'>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#F8FAFC !important", color: "#592375", padding: '10px' }}>
                      <TableCell className="fixed-col first-col" sx={{ width: 200 ,color: "#592375", paddingBlock: '20px' }}>Agent Name</TableCell>
                      <TableCell className="fixed-col second-col" sx={{ width: 130,color: "#592375", paddingBlock: '20px'  }}>Mobile.No</TableCell>
                      <TableCell className="fixed-col third-col" sx={{ width: 200,color: "#592375", paddingBlock: '20px'  }}>Bank Name</TableCell>
                      <TableCell sx={{ width: 130, color: "#592375", paddingBlock: '20px'  }}>Hardware Devices</TableCell>
                      <TableCell sx={{ width: 130, color: "#592375", paddingBlock: '20px'  }}>Total Amount</TableCell>
                      <TableCell sx={{ width: 130, color: "#592375", paddingBlock: '20px'  }}>Requested Amount</TableCell>
                      <TableCell sx={{ width: 130, color: "#592375", paddingBlock: '20px'  }}>Hardware Amount</TableCell>
                      <TableCell sx={{ width: 130, color: "#592375", paddingBlock: '20px'  }}>Signon Amount</TableCell>
                      <TableCell sx={{ width: 130, color: "#592375", paddingBlock: '20px'  }}>Due Amount</TableCell>
                      <TableCell sx={{ width: 130, color: "#592375", paddingBlock: '20px'  }}>Due Date</TableCell>
                      <TableCell sx={{ width: 130, color: "#592375", paddingBlock: '20px'  }}>Status</TableCell>
                      <TableCell sx={{ width: 130, color: "#592375", paddingBlock: '20px'  }}>View Request</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Data &&
                      Data
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row,index) => {
                          if (props.filter.name !== '' || props.filter.mobile_number !== '' || props.filter.bank !== '') {
                            if(
                              (props.filter.name !== '' && props.filter.mobile_number !== '' && row.agent_details.customer_details.customer_name.trim().toLowerCase().includes(props.filter.name) && row.agent_details.customer_details.customer_mobile.trim().toLowerCase().includes(props.filter.mobile_number.trim().toLowerCase()))
                              ||
                              (props.filter.name !== '' && props.filter.mobile_number === '' && row.agent_details.customer_details.customer_name.trim().toLowerCase().includes(props.filter.name.trim().toLowerCase()))
                              ||
                              (props.filter.mobile_number !== '' && props.filter.name === '' && row.agent_details.customer_details.customer_mobile.trim().toLowerCase().includes(props.filter.mobile_number.trim().toLowerCase()))
                            ) {
                              return (
                                // row.sh_approval_status===true&&sessionStorage.getItem('UserType')==='rm'||sessionStorage.getItem('UserType')==='sh'&&row.sh_approval_status===false?
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }} role="checkbox" tabIndex={-1} key={row.code}>
                                  <TableCell className="fixed-col first-col" sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5 !important" : "#fff !important" }}>{row.agent_details.customer_details ? row.agent_details.customer_details.customer_name : '-'}</TableCell>
                                  <TableCell className="fixed-col second-col" sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                    {row.agent_details.customer_details ? row.agent_details.customer_details.customer_mobile : '-'}
                                  </TableCell>
                                  <TableCell className="fixed-col third-col" sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                    {row.agent_details.product_details && Array.isArray(row.agent_details.product_details) && row.agent_details.product_details.length > 0 && row.agent_details.product_details[0] !== null ? row.agent_details.product_details[0].display_name : '-'}
                                  </TableCell>
                                  <TableCell sx={{ alignItems: 'center', backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                    {row.agent_details.device_id ? row.agent_details.device_id.length : ''}
                                  </TableCell>

                                  <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                    {row.agent_details.payment_details &&
                                      row.agent_details.payment_details.installment_1 &&
                                      row.agent_details.payment_details.installment_1.total_amount}
                                  </TableCell>


                                  {
                                    row && (row.request_type === 'tm_initiated' || row.request_type === 'ds_initiated' || row.request_type === 'ops_initiated') && (row.sh_hardware_updated_amount > 0 || row.sh_signon_updated_amount > 0) ?
                                      <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                        {row &&
                                          row.sh_signon_updated_amount &&
                                          row.sh_signon_updated_amount}
                                      </TableCell>

                                      :
                                      <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                        {row.agent_details.payment_details &&
                                          row.agent_details.payment_details.installment_1 &&
                                          row.agent_details.payment_details.installment_1.payment_requested}
                                      </TableCell>

                                  }
                                  {/* hardware */}

                                  {
                                    row && (row.request_type === 'tm_initiated' || row.request_type === 'ds_initiated' || row.request_type === 'ops_initiated') && (row.sh_hardware_updated_amount > 0 || row.sh_signon_updated_amount > 0) ?
                                      <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                        {row &&
                                          row.sh_signon_updated_amount &&
                                          row.sh_signon_updated_amount}
                                      </TableCell>

                                      :
                                      <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                        {row.agent_details.payment_details &&
                                          row.agent_details.payment_details.installment_1 &&
                                          row.agent_details.payment_details.installment_1.hardware_payment_requested}
                                      </TableCell>

                                  }
                                  {/* signon */}


                                  {
                                    row && (row.request_type === 'tm_initiated' || row.request_type === 'ds_initiated' || row.request_type === 'ops_initiated') && (row.sh_hardware_updated_amount > 0 || row.sh_signon_updated_amount > 0) ?
                                      <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                        {row &&
                                          row.sh_signon_updated_amount &&
                                          row.sh_signon_updated_amount}
                                      </TableCell>

                                      :
                                      <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                        {row.agent_details.payment_details &&
                                          row.agent_details.payment_details.installment_1 &&
                                          row.agent_details.payment_details.installment_1.signon_payment_requested}
                                      </TableCell>

                                  }

                                  {
                                    sessionStorage.getItem("UserType") === 'cso' && row && (row.request_type === 'tm_initiated' || row.request_type === 'ds_initiated' || row.request_type === 'ops_initiated') && (row.sh_hardware_updated_amount > 0 || row.sh_signon_updated_amount > 0) ?
                                      <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                        {row.agent_details.payment_details &&
                                          row.agent_details.payment_details.installment_1 &&
                                          row.agent_details.payment_details.installment_1.total_amount
                                          ? row.agent_details.payment_details.installment_1.total_amount -
                                          row.sh_updated_amount
                                          : '-'}
                                      </TableCell>
                                      :
                                      <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                        {row.agent_details.payment_details &&
                                          row.agent_details.payment_details.installment_1 &&
                                          row.agent_details.payment_details.installment_1.total_amount
                                          ? row.agent_details.payment_details.installment_1.total_amount -
                                          row.agent_details.payment_details.installment_1.payment_requested
                                          : '-'}
                                      </TableCell>
                                  }



                                  <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                    {row.agent_details.payment_details &&
                                      row.agent_details.payment_details.installment_1 &&
                                      row.agent_details.payment_details.installment_1.due_date
                                      ? row.agent_details.payment_details.installment_1.due_date
                                      : '-'}
                                  </TableCell>

                                  <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                    { (sessionStorage.getItem('UserType') === 'sh' && !row.sh_approval_status)
                                      ||
                                      (sessionStorage.getItem('UserType') === 'cso' && !row.cso_approval_status)
                                      ||
                                      (sessionStorage.getItem('UserType') === 'rm' && !row.rm_approval_status) ? (
                                      <Typography variant='h5' sx={{padding:'8px 12px 8px 12px', borderRadius:"8px",backgroundColor:"#FFB0A9",color:"#FF0000",textAlign:'center'}}>
                                        Pending
                                      </Typography>
                                    ) :

                                      (sessionStorage.getItem('UserType') === 'sh' && row.sh_approval_status)
                                        ||
                                        (sessionStorage.getItem('UserType') === 'cso' && row.cso_approval_status)
                                        ||
                                        (sessionStorage.getItem('UserType') === 'rm' && row.rm_approval_status) ?

                                        (
                                          <Typography variant='h5' sx={{padding:'8px 12px 8px 12px', borderRadius:"8px",backgroundColor:"#C3FED8",color:"#23B04B",textAlign:'center'}}>
                                            Approved
                                          </Typography>
                                        )
                                        :
                                        (
                                          <Typography variant='h5'>
                                            Not Available
                                          </Typography>
                                        )

                                    }
                                  </TableCell>

                                  <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>

                                    <Button variant="text" onClick={() => handleClickOpen(row)}>
                                      View
                                    </Button>

                                  </TableCell>


                                </TableRow>
                                // :
                                // null
                              );
                            }
                          }
                          else {
                            return (
                              // row.sh_approval_status===true&&sessionStorage.getItem('UserType')==='rm'||sessionStorage.getItem('UserType')==='sh'&&row.sh_approval_status===false?
                              <TableRow  role="checkbox" tabIndex={-1} key={row.code} sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>
                                <TableCell className="fixed-col first-col" sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5 !important" : "#fff !important" }}>{row.agent_details.customer_details ? row.agent_details.customer_details.customer_name : '-'}</TableCell>
                                <TableCell className="fixed-col second-col" sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5 !important" : "#fff !important" }}>
                                  {row.agent_details.customer_details ? row.agent_details.customer_details.customer_mobile : '-'}
                                </TableCell>
                                <TableCell className="fixed-col third-col" sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5 !important" : "#fff !important" }}>{row.agent_details.product_details && Array.isArray(row.agent_details.product_details) && row.agent_details.product_details.length > 0 && row.agent_details.product_details[0] !== null ? row.agent_details.product_details[0].display_name : '-'}</TableCell>
                                <TableCell sx={{ alignItems: 'center' }}>
                                  {row.agent_details.device_id ? row.agent_details.device_id.length : ''}
                                </TableCell>

                                <TableCell>
                                  {row.agent_details.payment_details &&
                                    row.agent_details.payment_details.installment_1 &&
                                    row.agent_details.payment_details.installment_1.total_amount}
                                </TableCell>

                                {
                                  sessionStorage.getItem("UserType") === 'cso' && row && (row.request_type === 'tm_initiated' || row.request_type === 'ds_initiated' || row.request_type === 'ops_initiated') && row.sh_updated_amount > 0 ?
                                    <TableCell>
                                      {row &&
                                        row.sh_updated_amount &&
                                        row.sh_updated_amount}
                                    </TableCell>

                                    :
                                    <TableCell>
                                      {row.agent_details.payment_details &&
                                        row.agent_details.payment_details.installment_1 &&
                                        row.agent_details.payment_details.installment_1.payment_requested ?
                                        row.agent_details.payment_details.installment_1.payment_requested
                                        :
                                        row.agent_details.payment_details.installment_1.payment_requested}
                                    </TableCell>

                                }

                                {
                                  sessionStorage.getItem("UserType") === 'cso' && row && (row.request_type === 'tm_initiated' || row.request_type === 'ds_initiated' || row.request_type === 'ops_initiated') && row.sh_updated_amount > 0 ?
                                    <TableCell>
                                      {row &&
                                        row.sh_updated_amount &&
                                        row.sh_updated_amount}
                                    </TableCell>

                                    :
                                    <TableCell>
                                      {row.agent_details.payment_details &&
                                        row.agent_details.payment_details.installment_1 &&
                                        row.agent_details.payment_details.installment_1.hardware_payment_requested ?
                                        row.agent_details.payment_details.installment_1.hardware_payment_requested
                                        :
                                        '-'}
                                    </TableCell>

                                }

                                {
                                  sessionStorage.getItem("UserType") === 'cso' && row && (row.request_type === 'tm_initiated' || row.request_type === 'ds_initiated' || row.request_type === 'ops_initiated') && row.sh_updated_amount > 0 ?
                                    <TableCell>
                                      {row &&
                                        row.sh_updated_amount &&
                                        row.sh_updated_amount}
                                    </TableCell>

                                    :
                                    <TableCell>
                                      {row.agent_details.payment_details &&
                                        row.agent_details.payment_details.installment_1 &&
                                        row.agent_details.payment_details.installment_1.signon_payment_requested ?
                                        row.agent_details.payment_details.installment_1.signon_payment_requested
                                        :
                                        '-'}
                                    </TableCell>

                                }

                                {
                                  sessionStorage.getItem("UserType") === 'cso' && row && (row.request_type === 'tm_initiated' || row.request_type === 'ds_initiated' || row.request_type === 'ops_initiated') && row.sh_updated_amount > 0 ?
                                    <TableCell>
                                      {row.agent_details.payment_details &&
                                        row.agent_details.payment_details.installment_1 &&
                                        row.agent_details.payment_details.installment_1.payment_requested
                                        ? row.agent_details.payment_details.installment_1.total_amount -
                                        row.sh_updated_amount
                                        : '-'}
                                    </TableCell>
                                    :
                                    <TableCell>
                                      {row.agent_details.payment_details &&
                                        row.agent_details.payment_details.installment_1 &&
                                        row.agent_details.payment_details.installment_1.payment_requested
                                        ? row.agent_details.payment_details.installment_1.total_amount -
                                        row.agent_details.payment_details.installment_1.payment_requested
                                        : row.agent_details.payment_details.installment_1.payment_requested
                                          ? row.agent_details.payment_details.installment_1.total_amount -
                                          row.agent_details.payment_details.installment_1.payment_requested : '-'}
                                    </TableCell>
                                }

                                <TableCell>
                                  {row.agent_details.payment_details &&
                                    row.agent_details.payment_details.installment_1 &&
                                    row.agent_details.payment_details.installment_1.due_date
                                    ? row.agent_details.payment_details.installment_1.due_date
                                    : '-'}
                                </TableCell>

                                <TableCell>
                                  {(sessionStorage.getItem('UserType') === 'sh' && !row.sh_approval_status)
                                    ||
                                    (sessionStorage.getItem('UserType') === 'cso' && !row.cso_approval_status)
                                    ||
                                    (sessionStorage.getItem('UserType') === 'rm' && !row.rm_approval_status) ? (
                                    <Typography variant='h6' sx={{padding:'8px 12px 8px 12px', borderRadius:"8px",backgroundColor:"#FFB0A9",color:"#FF0000",textAlign:'center'}}>
                                      Pending
                                    </Typography>
                                  )

                                    :

                                    (sessionStorage.getItem('UserType') === 'sh' && row.sh_approval_status)
                                      ||
                                      (sessionStorage.getItem('UserType') === 'cso' && row.cso_approval_status)
                                      ||
                                      (sessionStorage.getItem('UserType') === 'rm' && row.rm_approval_status) ?

                                      (
                                        <Typography variant='h6' sx={{padding:'8px 12px 8px 12px', borderRadius:"8px",backgroundColor:"#C3FED8",color:"#23B04B",textAlign:'center'}}>
                                          Approved
                                        </Typography>
                                      )

                                      :

                                      (
                                        <Typography variant='h5'>
                                          Not Available
                                        </Typography>
                                      )


                                  }
                                </TableCell>

                                <TableCell>

                                  <Button sx={{backgroundColor:"#E9EFFD",color:"#2563EB",borderRadius:'8px'}} variant="text" onClick={() => handleClickOpen(row)}>
                                    View
                                  </Button>

                                </TableCell>


                              </TableRow>
                              // :
                              // null
                            );
                          }
                        })}
                  </TableBody>
                </Table>
              </TableContainer>
              :
              <Stack>
                <Typography>No record found</Typography>
              </Stack>
          }

          <TablePagination
            sx={{ width: '100%' }}
            rowsPerPageOptions={[10]}
            component="div"
            count={Data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}
    </div>
  );
}
